import {
  TEXT_FIELD_ICON_CLASS_NAME,
  DEFAULT_ICON_CLASS_NAME,
  SECONDARY_ICON_CLASS_NAME,
  CONFIRMATION_ICON_CLASS_NAME,
  NAVBAR_ICON_CLASS_NAME,
  CARD_CORNER_ICON_CLASS_NAME,
} from '../../constants/icon';

const textFieldIcon = ({ theme }) => ({
  color: theme.palette.primary.main,
});

export const defaultIcon = ({ theme }) => ({
  color: theme.palette.primary.main,
});

export const secondaryIcon = ({ theme }) => ({
  color: theme.palette.primary.A500,
});

export const confirmationIcon = ({ theme }) => ({
  color: theme.palette.success.main,
  p: 0.5,
  backgroundColor: theme.palette.success.A100,
  borderRadius: '50%',
});

export const navbarIcon = ({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 24,
});

export const cardCornerIcon = ({ theme }) => ({
  position: 'absolute',
  top: 4,
  right: 4,
  fontSize: theme.typography.pxToRem(16),
  cursor: 'pointer',
  zIndex: 1,
  color: theme.palette.primary.main,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(14),
  },
});

const MuiIcon = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${TEXT_FIELD_ICON_CLASS_NAME}`]: textFieldIcon({ theme }),
      [`&.${DEFAULT_ICON_CLASS_NAME}`]: defaultIcon({ theme }),
      [`&.${SECONDARY_ICON_CLASS_NAME}`]: secondaryIcon({ theme }),
      [`&.${CONFIRMATION_ICON_CLASS_NAME}`]: confirmationIcon({ theme }),
      [`&.${NAVBAR_ICON_CLASS_NAME}`]: navbarIcon({ theme }),
      [`&.${CARD_CORNER_ICON_CLASS_NAME}`]: cardCornerIcon({ theme }),
    }),
  },
};

export default MuiIcon;
